import React, { useContext, useState, useEffect, useRef } from "react";
import { InfluencerProfileContainer, NetworkCount, ProfileImage } from "./InfluencerProfileStyled";
import { FormattedMessage, useIntl } from 'react-intl';
import ModalInfluencerVideo from "../../components/ModalInfluencerVideo/ModalInfluencerVideo";
import InfluencerProfileFirstSection from "../../components/InfluencerProfileFirstSection/InfluencerProfileFirstSection";
import MyProfileProducts from "../../components/MyProfileProducts/MyProfileProducts";

import { useNavigate, useParams } from 'react-router-dom';
import { LangContext } from "../../context/langContext";

import avatar from './../../utils/images/avatar_fluincr.png';
import arrowBack from './../../utils/images/arrow_back_black.svg';
import check from './../../utils/images/check_circle_darker.svg';
import edit from './../../utils/images/edit_white.svg';
import star from './../../utils/images/star.svg';
import play from './../../utils/images/play_grey.svg';
import share from './../../utils/images/share_white.svg';
import heart from './../../utils/images/heart.svg';

import tiktok from './../../utils/images/tiktok_color.svg';
import facebook from './../../utils/images/facebook_color.svg';
import instagram from './../../utils/images/instagram_color.svg';
import youtube from './../../utils/images/youtube_color.svg';
import twitter from './../../utils/images/twitter_color.svg';

import YoutubeIcon from "../../utils/images/NetworkIcon/YoutubeIcon";
import TwitterIcon from "../../utils/images/NetworkIcon/TwitterIcon";
import TikTokIcon from "../../utils/images/NetworkIcon/TikTokIcon";
import FacebookIcon from "../../utils/images/NetworkIcon/FacebookIcon";
import InstagramIcon from "../../utils/images/NetworkIcon/InstagramIcon";

import { toUpperCase } from "../../services/generalSevices";

import { deleteLikeToInfluencers, getCompanyLikeFromInfluencer, getInfluencerData, getServicesByInfluencer, postLikeToInfluencers } from "../../api/influencerApi";
import { getCompanyData, getInfluencerLikeFromCompany } from "../../api/companyApi";
import { UserContext } from "../../context/userContext";
import LikeCompany from "../../components/LikeCompany/LikeCompany";
import LikeProduct from "../../components/LikeProduct/LikeProduct";
import SocialMedia from "../../components/SocialMedia/SocialMedia";
import ModalCarouselCollaborations from "../../components/ModalCarouselCollaboration/ModalCarouselCollaboration";
import LikeInfluencer from "../../components/LikeInfluencer/LikeInfluencer";
import ModalCarousel from "../../components/ModalCarousel/ModalCarousel";
import { getCollaborationsByCompanyIdAndStatus, getCollaborationsByInfluencerIdAndStatus } from "../../api/collaborationApi";
import CollaborationCardPublicProfile from "../../components/CollaborationCardPublicProfile/CollaborationCardPublicProfile";
import Spinner from "../../components/Spinner/Spinner";

export default function InfluencerProfile() {

    const navigate = useNavigate();
    const shareRef = useRef(null);
    const { locale } = useContext(LangContext);
    const { userToken, userType, companyId, id, uniqueName } = useContext(UserContext);


    const { username } = useParams();
    const [isFavorite, setIsFavorite] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [youtubeSuscribers, setYoutubeSuscribers] = useState(0);
    const [twitterFollowers, setTwitterFollowers] = useState(0);
    const [tiktokFollowers, setTiktokFollowers] = useState(0);
    const [facebookFollowers, setFacebookFollowers] = useState(0);
    const [instagramFollowers, setInstagramrFollowers] = useState(0);

    const [profileId, setProfileId] = useState(null);
    const [profileImage, setProfileImage] = useState('');
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState({});
    const [languages, setLanguages] = useState([]);
    const [rating, setRating] = useState(null);
    const [description, setDescription] = useState(null);
    const [categories, setCategories] = useState([]);
    const [categoriesName, setCategoriesName] = useState([]);
    const [categoriesNombre, setCategoriesNombre] = useState([]);
    const [video, setVideo] = useState('');
    const [verified, setVerified] = useState(false);
    const [profileUserType, setProfileUserType] = useState('');

    const [gallery, setGallery] = useState([]);
    const [auxGallery, setAuxGallery] = useState([]);
    const [limitGallery, setLimitGallery] = useState(8);
    const [offsetGallery, setOffsetGallery] = useState(0);
    const [prices, setPrices] = useState([]);

    const [companyName, setCompanyName] = useState('');
    const [products, setProducts] = useState([])
    const [auxProducts, setAuxProducts] = useState([]);
    const [limitProducts, setLimitProducts] = useState(4);
    const [offsetProducts, setOffsetProducts] = useState(0);

    const [showModalVideo, setShowModalVideo] = useState(false);
    const [showSocialMedia, setShowSocialMedia] = useState(false);
    const url = window.location.href;

    const [collaboratorsInfluencer, setCollaboratorsInfluencer] = useState([]);

    let countProductsToShow = 0;

    //const [image, setImage] = useState([]);
    const [content, setContent] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showCarousel, setShowCarousel] = useState(false);

    const [collaborations, setCollaborations] = useState([]);

    const [callFavorite, setCallFavorite] = useState(false);

    let countCollaborationToShow = 0;

    const handlerMoreGallery = () => {
        setLimitGallery(limitGallery + 4)
        setOffsetGallery(limitGallery)
    }

    useEffect(() => {
        const newGallery = [...auxGallery].concat(gallery.slice(offsetGallery, limitGallery))
        setAuxGallery(newGallery)
    }, [limitGallery, offsetGallery])

    const handlerMoreProducts = () => {
        setLimitProducts(limitProducts + 4)
        setOffsetProducts(limitProducts)
    }

    useEffect(() => {
        const newProducts = [...auxProducts].concat(products.slice(offsetProducts, limitProducts))
        setAuxProducts(newProducts)
    }, [limitProducts, offsetProducts])

    useEffect(() => {
        setIsLoading(true);
        getInfluencerData({ userName: username }).then((response) => {
            setIsLoading(false);
            if (response.status === 404) {
                navigate('/error')
            } else {
                setProfileId(response.id)
                setProfileImage(response.imageProfile);
                setCity(response.city);
                setCountry(response.country);
                setVerified(response.attributes.verified)

                setRating(response.rating);
                setDescription(response.description);
                setVideo(response.videoProfile);
                setProfileUserType(response.attributes.typeUser);

                setTiktokFollowers(response.followers.tiktok);
                setTwitterFollowers(response.followers.twitter);
                setYoutubeSuscribers(response.followers.youtube);
                setFacebookFollowers(response.followers.facebook);
                setInstagramrFollowers(response.followers.instagram);

                getServicesByInfluencer({ influencerId: response.id }).then((responseServices) => {
                    setPrices(responseServices)
                })

                if (response.attributes.typeUser === 'Influencer') {
                    setName(response?.givenName)
                    setLastName(response?.familyName)
                    setGallery(response.gallery)
                    setAuxGallery(response.gallery.slice(0, limitGallery))
                    //setPrices(response.personalFare)

                } else {
                    setCompanyName(response?.nameCompany);
                    setProducts(response.product)
                    setAuxProducts(response.product.slice(0, limitProducts))

                }

                const auxLanguages = [];
                response.language?.map((language) => {
                    auxLanguages.push(language.languageId.convention)
                })
                setLanguages(auxLanguages)

                const auxCategories = [];
                const auxCategoriesNombre = [];
                response.category?.map((category) => {
                    auxCategories.push(category.categoryId.name)
                    auxCategoriesNombre.push(category.categoryId.nombre)
                })
                setCategories(auxCategories)
                setCategoriesName(auxCategories);
                setCategoriesNombre(auxCategoriesNombre);
                if (response.attributes.collaborators) {
                    setCollaboratorsInfluencer(response.attributes.collaborators)
                }
            }
        })

    }, [username, userToken])

    useEffect(() => {
        if (profileUserType === 'Influencer' && profileId !== null) {

            //Debe ser status 5 es decir las colaboraciones terminadas
            //Para pruebas está en status 3 
            getCollaborationsByInfluencerIdAndStatus({ influencerId: profileId, status: 5 }).then((response) => {
                setCollaborations(response)
            })
        }
        if (profileUserType === 'company' && profileId !== null) {

            getCollaborationsByCompanyIdAndStatus({ companyId: profileId, status: 5 }).then((response) => {
                setCollaborations(response)
            })
        }
    }, [profileUserType, profileId])

    useEffect(() => {
        if (profileUserType === 'company') {
            if (userToken === null) {
                navigate('/signin')
            }
            if ((uniqueName !== '') && (uniqueName !== username)) {
                if (userType === 'company') {
                    navigate('/error')
                }
            }
        }
    }, [profileUserType, uniqueName, username])

    useEffect(() => {
        function handleClickOutside(event) {

            if (shareRef.current && !shareRef.current.contains(event.target)) {
                setShowSocialMedia(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [shareRef])


    return (
        <InfluencerProfileContainer>
            <div className="banner">
                <div className="goBack" onClick={() => navigate(-1)}>
                    <img src={arrowBack} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>
                <div className="bannerInformation">
                    <div className="networkContainer">
                        <div>
                            <ProfileImage image={(profileImage !== '' && profileImage !== null) ? profileImage : avatar} />
                            <img src={play} alt="avatar" className="play" onClick={() => { setShowModalVideo(true) }} />
                        </div>

                        <div className="networks">
                            {(instagramFollowers !== undefined) &&
                                <div className="networkLine">
                                    <NetworkCount count={instagramFollowers}>
                                        <div className="instagramCount">
                                            <hr />
                                            <InstagramIcon />
                                        </div>
                                    </NetworkCount>
                                    <span>{(instagramFollowers < 999) ? instagramFollowers : (instagramFollowers < 999999) ? `${(instagramFollowers / 1000).toFixed(1)} k` : `${(instagramFollowers / 1000000).toFixed(1)} m`}</span>
                                </div>
                            }
                            {/*  <NetworkCount count={instagramFollowers}>
                                {(instagramFollowers !== undefined) &&
                                    <div className="instagramCount">
                                        <hr />
                                        <InstagramIcon />
                                        <span>{(instagramFollowers < 999) ? instagramFollowers : (instagramFollowers < 999999) ? `${(instagramFollowers / 1000).toFixed(1)} k` : `${(instagramFollowers / 1000000).toFixed(1)} m`}</span>
                                    </div>
                                }
                            </NetworkCount> */}

                            {(facebookFollowers !== undefined) &&
                                <div className="networkLine">
                                    <NetworkCount count={facebookFollowers}>
                                        <div className="facebookCount">
                                            <hr />
                                            <FacebookIcon />
                                        </div>
                                    </NetworkCount>
                                    <span>{(facebookFollowers < 999) ? facebookFollowers : (facebookFollowers < 999999) ? `${(facebookFollowers / 1000).toFixed(1)} k` : `${(facebookFollowers / 1000000).toFixed(1)} m`}</span>
                                </div>
                            }
                            {/*  <NetworkCount count={facebookFollowers}>
                                {(facebookFollowers !== undefined) &&
                                    <div className="facebookCount">
                                        <hr />
                                        <FacebookIcon />
                                        <span>{(facebookFollowers < 999) ? facebookFollowers : (facebookFollowers < 999999) ? `${(facebookFollowers / 1000).toFixed(1)} k` : `${(facebookFollowers / 1000000).toFixed(1)} m`}</span>
                                    </div>
                                }
                            </NetworkCount> */}

                            {(tiktokFollowers !== undefined) &&
                                <div className="networkLine">
                                    <NetworkCount count={tiktokFollowers}>
                                        <div className="tiktokCount">
                                            <hr />
                                            <TikTokIcon />

                                        </div>
                                    </NetworkCount>
                                    <span>{(tiktokFollowers < 999) ? tiktokFollowers : (tiktokFollowers < 999999) ? `${(tiktokFollowers / 1000).toFixed(1)} k` : `${(tiktokFollowers / 1000000).toFixed(1)} m`}</span>
                                </div>
                            }
                            {/* <NetworkCount count={tiktokFollowers}>
                                {(tiktokFollowers !== undefined) &&
                                    <div className="tiktokCount">
                                        <hr />
                                        <TikTokIcon />
                                        <span>{(tiktokFollowers < 999) ? tiktokFollowers : (tiktokFollowers < 999999) ? `${(tiktokFollowers / 1000).toFixed(1)} k` : `${(tiktokFollowers / 1000000).toFixed(1)} m`}</span>
                                    </div>
                                }
                            </NetworkCount> */}

                            {(youtubeSuscribers !== undefined) &&
                                <div className="networkLine">
                                    <NetworkCount count={youtubeSuscribers}>
                                        <div className="youtubeCount">
                                            <hr />
                                            <YoutubeIcon />
                                        </div>
                                    </NetworkCount>
                                    <span>{(youtubeSuscribers < 999) ? youtubeSuscribers : (youtubeSuscribers < 999999) ? `${(youtubeSuscribers / 1000).toFixed(1)} k` : `${(youtubeSuscribers / 1000000).toFixed(1)} m`}</span>
                                </div>
                            }
                            {/* <NetworkCount count={youtubeSuscribers}>
                                {(youtubeSuscribers !== undefined) &&
                                    <div className="youtubeCount">
                                        <hr />
                                        <YoutubeIcon />
                                        <span>{(youtubeSuscribers < 999) ? youtubeSuscribers : (youtubeSuscribers < 999999) ? `${(youtubeSuscribers / 1000).toFixed(1)} k` : `${(youtubeSuscribers / 1000000).toFixed(1)} m`}</span>
                                    </div>
                                }
                            </NetworkCount> */}

                            {(twitterFollowers !== undefined) &&
                                <div className="networkLine">
                                    <NetworkCount count={twitterFollowers}>
                                        <div className="twitterCount">
                                            <hr />
                                            <TwitterIcon />
                                        </div>
                                    </NetworkCount>
                                    <span>{(twitterFollowers < 999) ? twitterFollowers : (twitterFollowers < 999999) ? `${(twitterFollowers / 1000).toFixed(1)} k` : `${(twitterFollowers / 1000000).toFixed(1)} m`}</span>
                                </div>
                            }
                            {/*  <NetworkCount count={twitterFollowers}>
                                {(twitterFollowers !== undefined) &&
                                    <div className="twitterCount">
                                        <hr />
                                        <TwitterIcon />
                                        <span>{(twitterFollowers < 999) ? twitterFollowers : (twitterFollowers < 999999) ? `${(twitterFollowers / 1000).toFixed(1)} k` : `${(twitterFollowers / 1000000).toFixed(1)} m`}</span>
                                    </div>
                                }
                            </NetworkCount> */}
                        </div>


                    </div>
                    <div className="data">
                        <div className="fileName">
                            {/* {(profileUserType === 'Influencer') ? (<p className="name">{(toUpperCase({ fullName: `${name.split(' ')[0]} ${(name.split(' ')[1] !== undefined) ? (name.split(' ')[1]?.charAt(0)) : ('')} ${lastName.split(' ')[0]}` }))}</p>) : (<p className="name">{companyName}</p>)} */}

                            {(profileUserType === 'Influencer') ? (<p className="name">{(toUpperCase({ fullName: `${name} ${lastName}` }))}</p>) : (<p className="name">{toUpperCase({ fullName: companyName })}</p>)}

                            {(verified) && (<div className="checkContainer">
                                <img src={check} alt="check" className="check" />
                            </div>)}


                            {((userType === 'company' && profileUserType !== 'company') || userToken === null) ? (
                                <div className="likeInfluencerContainer"><LikeInfluencer profileId={profileId} isFavorite={isFavorite} setIsFavorite={setIsFavorite} /></div>) : (<div className="favorite" />)}

                            {(userType === 'influencer' && profileUserType !== 'Influencer') && (<div className="likeCompanyContainer"><LikeCompany profileId={profileId} /></div>)}

                            {/* <img src={whiteStar} alt="like" className="like" /> */}
                        </div>

                        <div className="firstFile">
                            <div className="item">
                                <p className="city">
                                    {(city !== null) && (<p>
                                        {(locale === 'es-CO') ? country?.nombre : country?.name},
                                        {` ${city}`}
                                    </p>)}
                                </p>
                            </div>
                            <div className="items">
                                <div className="subItem">
                                    <p className="language">
                                        {(languages[0] !== '') &&
                                            (<span>
                                                {languages.map((lang, index) => {
                                                    if (index < 1) {
                                                        //const langNot = lang.split('-')[1]
                                                        return (lang)
                                                    } else {
                                                        //const langNot = `/ ${lang.split('-')[1]}`
                                                        return (`/ ${lang}`)
                                                    }
                                                })}
                                            </span>)
                                        }
                                    </p>
                                </div>

                                <div className="share" ref={shareRef}>
                                    <img src={share} alt="edit" className="shareIcon" onClick={() => { setShowSocialMedia(!showSocialMedia) }} />
                                    {(showSocialMedia) && (<SocialMedia shareUrl={url} />)}
                                </div>


                                <div className="subItem">
                                    <p className="score">{(rating === null) ? 'N/R' : rating}</p>
                                    <img src={star} alt="star" className="star" />
                                </div>

                            </div>
                        </div>
                        <div className="descriptionContainer" >

                            {(description === null || description === '') ?
                                (<div className="descriptionEmpty">
                                    <div className="item">
                                        <hr />
                                        <hr />
                                        <hr />
                                    </div>
                                </div>) :
                                (<div className="descriptionContent">
                                    <p>{description}</p>
                                </div>)}
                        </div>
                        <div className="lastFile" >
                            <p className="categories">
                                {/*  {(categories[0] !== '') && (<p>
                                    {categories.map((categ, index) => {
                                        if (index < 4) {
                                            return `#${categ} `
                                        }
                                    })}
                                </p>)} */}
                                {(locale === 'es-CO') ? ((categories[0] !== '') && (<p>
                                    {categoriesNombre.map((categ, index) => {
                                        if (index < 4) {
                                            return `#${categ} `
                                        }
                                    })}
                                </p>)) : ((categories[0] !== '') && (<p>
                                    {categoriesName.map((categ, index) => {
                                        if (index < 4) {
                                            return `#${categ} `
                                        }
                                    })}
                                </p>))}
                            </p>
                        </div>

                    </div>
                    <div className="networkMobile">
                        {(tiktokFollowers !== undefined) && (<div className="contentNetwork">
                            <div className="network">
                                <img src={tiktok} alt="tiktok followers" className="networkIcon" />
                            </div>
                            <p className="followersCount"><span>{(tiktokFollowers < 999) ? tiktokFollowers : `${(tiktokFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>)}

                        {(facebookFollowers !== undefined) && (<div className="contentNetwork">
                            <div className="network">
                                <img src={facebook} alt="facebook followers" className="networkIcon" />
                            </div>
                            <p className="followersCount"><span>{(facebookFollowers < 999) ? facebookFollowers : `${(facebookFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>)}

                        {(instagramFollowers !== undefined) && (<div className="contentNetwork">
                            <div className="network">
                                <img src={instagram} alt="instagram followers" className="networkIcon" />
                            </div>
                            <p className="followersCount"><span>{(instagramFollowers < 999) ? instagramFollowers : `${(instagramFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>)}

                        {(youtubeSuscribers !== undefined) && (<div className="contentNetwork">
                            <div className="network">
                                <img src={youtube} alt="youtube suscribers" className="networkIcon" />
                            </div>
                            <p className="followersCount"><span>{(youtubeSuscribers < 999) ? youtubeSuscribers : `${(youtubeSuscribers / 1000).toFixed(2)} m`}</span></p>
                        </div>)}

                        {(twitterFollowers !== undefined) && (<div className="contentNetwork">
                            <div className="network">
                                <img src={twitter} alt="twitter followers" className="networkIcon" />
                            </div>
                            <p className="followersCount"><span>{(twitterFollowers < 999) ? twitterFollowers : `${(twitterFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>)}

                    </div>
                </div>

            </div>
            <div className="myProfileBody">

                {(profileUserType === 'Influencer') && (<InfluencerProfileFirstSection prices={prices} isFavorite={isFavorite} setIsFavorite={setIsFavorite} collaborators={collaboratorsInfluencer} influencerId={profileId} />)}

                {(profileUserType === 'company') && (<div className="productsCardsContainer">
                    <div className="title">
                        <h3><FormattedMessage id="influencer_profile_subtitle_1" defaultMessage="Productos" /></h3>
                    </div>
                    <div className="productsCards">
                        {products.map((product) => {
                            if (product.showInProfile) {
                                countProductsToShow += 1;
                                return (<div className="front" style={{ backgroundImage: `url(${product.image})` }} key={product.id}>
                                    {(uniqueName !== username) && (<div className='likeProductContainer'>
                                        <LikeProduct product={product} />
                                    </div>)}

                                    {/* <img src={heart} alt="like" className="likeCompany" /> */}
                                    {/* <p className="productName">{product.name}</p> */}

                                    <div className="productName">
                                        {(product.link !== '') ? (<a href={product.link} target="_blank"> <p>{product.name}</p></a>) : (<p>{product.name}</p>)}
                                    </div>
                                </div>)
                            }

                        })}
                    </div>
                    {(countProductsToShow < 1) && (<div className="noContent" onClick={handlerMoreProducts}>
                        <p ><FormattedMessage id="influencer_profile_text_1" defaultMessage="No hay productos" /></p>
                    </div>)}

                    {/* {(auxProducts < products) && (<div className="more" onClick={handlerMoreProducts}>
                        <p ><FormattedMessage id="home_more_text" defaultMessage="Ver más +" /></p>
                    </div>)} */}

                    {/* {(products.filter((prod) => prod.showInProfile === true).length > limitProducts + offsetProducts) && (<div className="more" onClick={handlerMoreProducts}>
                        <p ><FormattedMessage id="home_more_text" defaultMessage="Ver más +" /></p>
                    </div>)} */}


                </div>)}

                <div className="collaborationsCardsContainer">
                    <div className="title">
                        <h3><FormattedMessage id="influencer_profile_subtitle_2" defaultMessage="Colaboraciones" /></h3>
                        {/* <p className="more"><FormattedMessage id="home_more_text" defaultMessage="Ver más +" /></p> */}
                    </div>


                    <div className="collaborationCards">

                        {collaborations.map((collaboration) => {
                            if (collaboration.publicprofileinfluencer === true && profileUserType === 'Influencer') {
                                countCollaborationToShow += 1;
                                return (<CollaborationCardPublicProfile collaboration={collaboration} profileUserType={profileUserType} />)
                            }
                            if (collaboration.publicprofilecompany === true && profileUserType === 'company') {
                                countCollaborationToShow += 1;
                                return (<CollaborationCardPublicProfile collaboration={collaboration} profileUserType={profileUserType} />)
                            }

                        })}

                        {(collaborations.length < 1 || countCollaborationToShow === 0) && (<div className="notContent">
                            <p><FormattedMessage id="public_profile_text_1" defaultMessage="Contenido no disponible" /></p>
                        </div>)}

                    </div>
                    {/* <div className="more">
                        <p ><FormattedMessage id="home_more_text" defaultMessage="Ver más +" /></p>
                    </div> */}

                </div>

                {(profileUserType === 'Influencer') && (
                    <div className="galeryCardsContainer">
                        <div className="title">
                            <h3>{/* <FormattedMessage id="influencer_profile_subtitle_3" defaultMessage="Galería" /> */}<FormattedMessage id="my_profile_subtitle_3" defaultMessage="Contenido" /></h3>
                        </div>

                        <div className="galeryCards">
                            {(auxGallery.length > 0) ? (auxGallery.map((photo, index) => {
                                return (<div className="front" style={{ backgroundImage: `url(${photo})` }} onClick={() => {
                                    //setImage([photo])
                                    setContent(auxGallery);
                                    setActiveIndex(index);
                                    setShowCarousel(true)
                                }}>
                                </div>)
                            })) : (<div className="notContent">
                                <p><FormattedMessage id="public_profile_text_1" defaultMessage="Contenido no  disponible" /></p>
                            </div>)}

                        </div>
                        {(auxGallery < gallery) && (<div className="more" onClick={handlerMoreGallery}>
                            <p ><FormattedMessage id="home_more_text" defaultMessage="Ver más +" /></p>
                        </div>)}

                    </div>)}

            </div>

            {(showModalVideo) && (<ModalInfluencerVideo setShowModalVideo={setShowModalVideo} video={video} />)}

            {/* {(showCarouselCollaboration) && (<ModalCarouselCollaborations images={collaborationsContent} setShowModalCarousel={setShowCarouselCollaboration} />)} */}

            {(showCarousel) && (<ModalCarousel /* images={image} */ setShowModalCarousel={setShowCarousel} content={content} activeIndex={activeIndex} page='profile' />)}

            {(isLoading) && (<Spinner />)}

        </InfluencerProfileContainer>
    )
}